import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_POSITION_API } from "../apiRoutes";

interface UseGetBOMPositionsProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBOMPositions = async (communityId: string) =>
  await axiosAuth.get(`${BOM_POSITION_API}/community/${communityId}`);

const useGetBOMPositions = ({
  communityId,
  queryParams,
}: UseGetBOMPositionsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bomPositions", communityId],
    queryFn: () => getBOMPositions(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetBOMPositions;
